var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-information SlimContainerWithTopMarginWhiteBg" },
    [
      _c("v-container", [
        _c(
          "div",
          { staticClass: "page-information__content" },
          [
            _vm.showPrintContentButton || _vm.showDownloadContentButton
              ? _c("download-content-buttons", {
                  attrs: {
                    pagePartId: _vm.pagePartId,
                    showPrintContentButton: _vm.showPrintContentButton,
                    showDownloadContentButton: _vm.showDownloadContentButton
                  }
                })
              : _vm._e(),
            _c("page-parts", {
              ref: "containerContent",
              attrs: { items: _vm.items }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }